import request from '@/utils/request'

const customerServiceBaseUrl = '/CustomerService'

export function startOrContinueChat(data) {
  return request({
    url: `${customerServiceBaseUrl}/StartOrContinueChat`,
    method: 'post',
    data,
  })
}

export function getConversationList() {
  return request({
    url: `${customerServiceBaseUrl}/GetConversationList`,
    method: 'get',
  })
}

export function getConversationMessages(conversationRecordId) {
  return request({
    url: `${customerServiceBaseUrl}/GetConversationMessages`,
    method: 'get',
    params: { conversationRecordId },
  })
}

export function getManualConversationMessages(conversationRecordId) {
  return request({
    url: `${customerServiceBaseUrl}/GetManualConversationMessages`,
    method: 'get',
    params: { conversationRecordId },
  })
}

export function submitCustomerServiceFeedback(data) {
  return request({
    url: `${customerServiceBaseUrl}/SubmitFeedback`,
    method: 'post',
    data,
  })
}

export function getConversationStarters(data) {
  return request({
    url: `${customerServiceBaseUrl}/GetConversationStarters`,
    method: 'post',
    data,
  })
}

export function transferToHuman(data) {
  return request({
    url: `${customerServiceBaseUrl}/TransferToHuman`,
    method: 'post',
    data,
  })
}

export function getManualServiceQueue() {
  return request({
    url: `${customerServiceBaseUrl}/GetManualServiceQueue`,
    method: 'get',
  })
}

export function takeOverConversation(data) {
  return request({
    url: `${customerServiceBaseUrl}/TakeOverConversation`,
    method: 'post',
    data,
  })
}

export function sendManualReply(data) {
  return request({
    url: `${customerServiceBaseUrl}/SendManualReply`,
    method: 'post',
    data,
  })
}

export function finishManualService(data) {
  return request({
    url: `${customerServiceBaseUrl}/FinishManualService`,
    method: 'post',
    data,
  })
}
